import React from 'react';
import PropTypes from 'prop-types';
import { SingleExample } from '../SingleExample';
import { Accordion } from '../../PageElements/Accordion';
import { StoreContext } from '../../../appContext/StoreProvider';

export const MultipleExamples = ({
  examples,
  data,
  prefix,
  isSingleExample,
  JSLayoutType,
}) => {
  const { store } = React.useContext(StoreContext);
  const shouldOpenAllExamplesOnStart =
    !!store.viewer.viewerConfig?.displayOptions?.openAllExamplesOnStart;

  const examplesForAccordion = examples.map((example, index) => ({
    content: (
      <SingleExample
        example={{ ...example, title: '' }}
        data={data}
        prefix={prefix}
        isSingleExample={isSingleExample}
        JSLayoutType={JSLayoutType}
      />
    ),
    title:
      !example.title || example.title === ''
        ? `Example ${index + 1}`
        : example.title,
    open: shouldOpenAllExamplesOnStart || index === 0,
  }));

  return (
    <Accordion
      data={examplesForAccordion}
      shouldAllowOpeningMultipleExamples={shouldOpenAllExamplesOnStart}
      dataHook="examples-accordion"
      prefix={prefix}
      articleUrlFormat={data.urlFormat}
    />
  );
};

MultipleExamples.propTypes = {
  examples: PropTypes.any,
  data: PropTypes.any,
  prefix: PropTypes.string,
  shouldOpenAllExamplesOnStart: PropTypes.bool,
};
